// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import Image from 'components/Image/Image'

class PostTileHorImageMedium extends React.Component {
	constructor() {
		super()

		this.state = {
			wapointEntered: false
		}
	}

	handleWaypointEnter = () => {
		const { wapointEntered } = this.state

		// Only trigger once:
		if ( wapointEntered ) {
			return
		}

		this.setState({
			wapointEntered: true
		})

		this.props.handleWaypointEnter()
	}

	handleClick = ( e ) => {
		if ( this.props.onClick ) {
			this.props.onClick( e )
		}
	}

	render() {
		let { url, title, excerpt, category, author, date, image, imageAlt, number, buttonColor } = this.props
		let buttonStyle = buttonColor ? {
			backgroundColor: buttonColor
		} : {}

		return (
			<Link className="post-tile is-horizontal is-medium with-image" to={ url } onClick={ this.handleClick }>
				{ this.props.handleWaypointEnter &&
					<Waypoint
						onEnter={ this.handleWaypointEnter }
					/>
				}

				{ number &&
					<div className="ideal-image -image-with-number">
						<div className="-number">{ number }</div>

						<Image
							thumb={ image.thumb }
							url={ image.url }
							srcset={ image.srcset }
							sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 200px` }
							alt={ imageAlt }
							focalPoint={ image.focal_point }
							width={ image.width }
							height={ image.height }
						/>
					</div>
				||
					<Image
						thumb={ image.thumb }
						url={ image.url }
						srcset={ image.srcset }
						sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 200px` }
						alt={ imageAlt }
						focalPoint={ image.focal_point }
						width={ image.width }
						height={ image.height }
					/>
				}

				<div className="-text">
					{ category &&
						<div className="-category">{ category }</div>
					}

					<h3 className="-title">{ title }</h3>

					{ excerpt &&
						<div className="-excerpt" dangerouslySetInnerHTML={ { __html: excerpt } } />
					}

					<div className="-author-date">
						<div className="-author">{ author }</div>
						<div className="-date">{ date }</div>
					</div>

					<div className="-read" style={ buttonStyle }>Read Now</div>
				</div>
			</Link>
		)
	}
}

export default PostTileHorImageMedium
